import {json} from '../core/data-source/json.mapper';

export class StopSequenceRecord {
    @json() value: number;

    @json() name: string;
}
